import { AlertTriangleIcon } from "lucide-react";
import { ErrorReportButton } from "./error-report-button";

// Function to get user-friendly error title based on status code
const getErrorTitle = (statusCode) => {
    if (!statusCode) {
        return "Something went wrong";
    }

    switch (statusCode) {
        case 400:
            return "Invalid Request";
        case 401:
            return "Please sign in again";
        case 403:
            return "You don't have permission";
        case 404:
            return "Not found";
        case 409:
            return "This already exists";
        case 422:
            return "Please check your information";
        case 429:
            return "Too many requests - please try again later";
        case 500:
            return "Server error - we're working on it";
        case 502:
            return "Service temporarily unavailable";
        case 503:
            return "Service temporarily unavailable";
        case 504:
            return "Request timed out - please try again";
        default:
            if (statusCode >= 400 && statusCode < 500) {
                return "Request error";
            } else if (statusCode >= 500) {
                return "Server error - we're working on it";
            }
            return "Something went wrong";
    }
};

export function ErrorReportToast({ closeToast, data }) {
    const errorTitle = getErrorTitle(data?.statusCode);
    return (
        <div className="flex flex-col w-full">
            <h3 className="text-zinc-500 text-xs font-medium flex items-center gap-2">
                <AlertTriangleIcon className="size-3 text-grey-700" /> {errorTitle}
            </h3>

            <div className="pl-5 mt-1">
                <p className="text-sm font-semibold text-zinc-800">{data.message}</p>
                <div className="flex items-center gap-2 mt-2">
                    <ErrorReportButton closeToast={closeToast} data={data} />
                </div>
            </div>
        </div>
    );
}